module.exports={
  "53001": {
    "key": 53001,
    "county": "Adams County",
    "el_id": "Adams"
  },
  "53003": {
    "key": 53003,
    "county": "Asotin County",
    "el_id": "Asotin"
  },
  "53005": {
    "key": 53005,
    "county": "Benton County",
    "el_id": "Benton"
  },
  "53007": {
    "key": 53007,
    "county": "Chelan County",
    "el_id": "Chelan"
  },
  "53009": {
    "key": 53009,
    "county": "Clallam County",
    "el_id": "Clallam"
  },
  "53011": {
    "key": 53011,
    "county": "Clark County",
    "el_id": "Clark"
  },
  "53013": {
    "key": 53013,
    "county": "Columbia County",
    "el_id": "Columbia"
  },
  "53015": {
    "key": 53015,
    "county": "Cowlitz County",
    "el_id": "Cowlitz"
  },
  "53017": {
    "key": 53017,
    "county": "Douglas County",
    "el_id": "Douglas"
  },
  "53019": {
    "key": 53019,
    "county": "Ferry County",
    "el_id": "Ferry"
  },
  "53021": {
    "key": 53021,
    "county": "Franklin County",
    "el_id": "Franklin"
  },
  "53023": {
    "key": 53023,
    "county": "Garfield County",
    "el_id": "Garfield"
  },
  "53025": {
    "key": 53025,
    "county": "Grant County",
    "el_id": "Grant"
  },
  "53027": {
    "key": 53027,
    "county": "Grays Harbor County",
    "el_id": "Grays_Harbor"
  },
  "53029": {
    "key": 53029,
    "county": "Island County",
    "el_id": "Island"
  },
  "53031": {
    "key": 53031,
    "county": "Jefferson County",
    "el_id": "Jefferson"
  },
  "53033": {
    "key": 53033,
    "county": "King County",
    "el_id": "King"
  },
  "53035": {
    "key": 53035,
    "county": "Kitsap County",
    "el_id": "Kitsap"
  },
  "53037": {
    "key": 53037,
    "county": "Kittitas County",
    "el_id": "Kittitas"
  },
  "53039": {
    "key": 53039,
    "county": "Klickitat County",
    "el_id": "Klickitat"
  },
  "53041": {
    "key": 53041,
    "county": "Lewis County",
    "el_id": "Lewis"
  },
  "53043": {
    "key": 53043,
    "county": "Lincoln County",
    "el_id": "Lincoln"
  },
  "53045": {
    "key": 53045,
    "county": "Mason County",
    "el_id": "Mason"
  },
  "53047": {
    "key": 53047,
    "county": "Okanogan County",
    "el_id": "Okanogan"
  },
  "53049": {
    "key": 53049,
    "county": "Pacific County",
    "el_id": "Pacific"
  },
  "53051": {
    "key": 53051,
    "county": "Pend Oreille County",
    "el_id": "Pend_Oreille"
  },
  "53053": {
    "key": 53053,
    "county": "Pierce County",
    "el_id": "Pierce"
  },
  "53055": {
    "key": 53055,
    "county": "San Juan County",
    "el_id": "San_Juan"
  },
  "53057": {
    "key": 53057,
    "county": "Skagit County",
    "el_id": "Skagit"
  },
  "53059": {
    "key": 53059,
    "county": "Skamania County",
    "el_id": "Skamania"
  },
  "53061": {
    "key": 53061,
    "county": "Snohomish County",
    "el_id": "Snohomish"
  },
  "53063": {
    "key": 53063,
    "county": "Spokane County",
    "el_id": "Spokane"
  },
  "53065": {
    "key": 53065,
    "county": "Stevens County",
    "el_id": "Stevens"
  },
  "53067": {
    "key": 53067,
    "county": "Thurston County",
    "el_id": "Thurston"
  },
  "53069": {
    "key": 53069,
    "county": "Wahkiakum County",
    "el_id": "Wahkiakum"
  },
  "53071": {
    "key": 53071,
    "county": "Walla Walla County",
    "el_id": "Walla_Walla"
  },
  "53073": {
    "key": 53073,
    "county": "Whatcom County",
    "el_id": "Whatcom"
  },
  "53075": {
    "key": 53075,
    "county": "Whitman County",
    "el_id": "Whitman"
  },
  "53077": {
    "key": 53077,
    "county": "Yakima County",
    "el_id": "Yakima"
  }
}